import type { ReactElement } from 'react';
import { Columns } from '../layout.jsx';
import { Preview } from '../preview.jsx';
import { Settings } from './settings.jsx';
import type { Props } from './types.js';
// import { Caveat } from '#~/common/editor/index.js';

/** `<Video>` panel. */
export const Video = (props: Props): ReactElement => {
  return (
    <div {...props}>
      {/* <h2>Video configuration</h2> */}
      {/* <Caveat title='Depending on the make and model of your camera, you may be required to reboot the device for any edits to apply.' /> */}

      {/* <HRule /> */}

      <Columns>
        <Columns.Column>
          <h3>Video settings</h3>
          <Settings />
        </Columns.Column>

        <Columns.Column>
          <h3>Video preview</h3>
          <Preview />
          {/* <Tally /> */}
        </Columns.Column>
      </Columns>
    </div>
  );
};
